import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "pi pi-lock"
}
const _hoisted_3 = {
  key: 1,
  class: "pi pi-unlock"
}
const _hoisted_4 = {
  key: 1,
  class: "col-12 flex flex-row flex-wrap"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "flex flex-wrap" }
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = { class: "ml-3 mt-1 compass-red" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.title && _ctx.title.length > 0)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editMode=!_ctx.editMode))
          }, [
            (!_ctx.editMode)
              ? (_openBlock(), _createElementBlock("i", _hoisted_2))
              : _createCommentVNode("", true),
            (_ctx.editMode)
              ? (_openBlock(), _createElementBlock("i", _hoisted_3))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.editMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleBillingEntities, (billingEntity) => {
            return (_openBlock(), _createElementBlock("div", {
              key: billingEntity.billingEntityId,
              class: "card mr-3 mb-3",
              style: {"width":"480px"}
            }, [
              _createElementVNode("i", {
                onClick: ($event: any) => (_ctx.removeEntity(billingEntity)),
                class: "pi pi-times",
                style: {"cursor":"pointer","float":"right","top":"-10px","position":"relative"}
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                _cache[1] || (_cache[1] = _createElementVNode("label", null, "Billing Entity Name", -1)),
                _createVNode(_component_InputText, {
                  modelValue: billingEntity.billingEntityName,
                  "onUpdate:modelValue": ($event: any) => ((billingEntity.billingEntityName) = $event),
                  onChange: _ctx.ensureEmptyEntity
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[2] || (_cache[2] = _createElementVNode("label", null, "Account Number", -1)),
                _createVNode(_component_InputText, {
                  modelValue: billingEntity.accountNumber,
                  "onUpdate:modelValue": ($event: any) => ((billingEntity.accountNumber) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.editMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleBillingEntities, (billingEntity) => {
              return (_openBlock(), _createElementBlock("div", {
                key: billingEntity.billingEntityId,
                class: "item-border-left"
              }, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(billingEntity.billingEntityName), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(billingEntity.accountNumber), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}